export const USD_TOKEN = { symbol: 'USD', address: 'usd' };
